export default "__VITE_ASSET__DiKyeVvg__"